cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label,
    },

    tick (d) {
        const minutes = d.getMinutes();
        const hours = d.getHours();
        const time = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
        this.label.string = time;
    }
});